import { render } from "./TablePassengers.vue?vue&type=template&id=03021eb0&scoped=true"
import script from "./TablePassengers.vue?vue&type=script&lang=js"
export * from "./TablePassengers.vue?vue&type=script&lang=js"

import "./TablePassengers.vue?vue&type=style&index=0&id=03021eb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03021eb0"]])

export default __exports__